import { defineMessages } from 'react-intl-next';

export const i18n: {
	dateFilterAfterLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	dateFilterAnyTime: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	dateFilterBeforeLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	dateFilterCustom: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	dateFilterCustomInvalidDateAfterEnd: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	dateFilterCustomInvalidDateAfterToday: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	dateFilterCustomInvalidToDateAfterToday: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	dateFilterDateInputPlaceholder: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	dateFilterFromTitle: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	dateFilterLastMonth: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	dateFilterLastWeek: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	dateFilterLastYear: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	dateFilterTitle: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	dateFilterToday: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	dateFilterToRange: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	dateFilterToTitle: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	dateFilterUpdateButton: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	dateFilterYesterday: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	dateFilterTitle: {
		id: 'dynamic-cards-search-page.date.filter.title',
		defaultMessage: 'Last updated',
		description:
			'Text to open the select filter by date content was modified dropdown in the Dynamic Cards Search modal that opens when user is updating filters for dynamic cards',
	},
	dateFilterFromTitle: {
		id: 'dynamic-cards-search-page.date.filter.from.title',
		defaultMessage: 'From',
		description:
			'Filter starting from a custom date in the Dynamic Cards Search modal that opens when user is updating dynamic cards',
	},
	dateFilterToTitle: {
		id: 'dynamic-cards-search-page.date.filter.to.title',
		defaultMessage: 'To',
		description:
			'Filter up to a custom date in the Dynamic Cards Search modal that opens when user is updating dynamic cards',
	},
	dateFilterDateInputPlaceholder: {
		id: 'dynamic-cards-search-page.date.filter.input.placeholder',
		defaultMessage: 'Choose a date',
		description:
			'Placeholder text for date input in the Dynamic Cards Search modal that opens when user is updating dynamic cards',
	},
	dateFilterAnyTime: {
		id: 'dynamic-cards-search-page.date.filter.any.time',
		defaultMessage: 'Anytime',
		description:
			'Option to show content from any time in the date input in the Dynamic Cards Search modal that opens when user is updating dynamic cards',
	},
	dateFilterToday: {
		id: 'dynamic-cards-search-page.date.filter.today',
		defaultMessage: 'Today',
		description:
			'Option to show content modified today in the date input in the Dynamic Cards Search modal that opens when user is updating dynamic cards',
	},
	dateFilterYesterday: {
		id: 'dynamic-cards-search-page.date.filter.yesterday',
		defaultMessage: 'Yesterday',
		description:
			'Option to show content modified yesterday in the date input in the Dynamic Cards Search modal that opens when user is updating dynamic cards',
	},
	dateFilterLastWeek: {
		id: 'dynamic-cards-search-page.date.filter.last.week',
		defaultMessage: 'Past 7 days',
		description:
			'Option to show content modified in the last 7 days in the date input in the Dynamic Cards Search modal that opens when user is updating dynamic cards',
	},
	dateFilterLastMonth: {
		id: 'dynamic-cards-search-page.date.filter.last.month',
		defaultMessage: 'Past 30 days',
		description:
			'Option to show content modified in the last 30 days in the date input in the Dynamic Cards Search modal that opens when user is updating dynamic cards',
	},
	dateFilterLastYear: {
		id: 'dynamic-cards-search-page.date.filter.last.year',
		defaultMessage: 'Past year',
		description:
			'Option to show content modified in the last 365 days in the date input in the Dynamic Cards Search modal that opens when user is updating dynamic cards',
	},
	dateFilterCustom: {
		id: 'dynamic-cards-search-page.date.filter.custom',
		defaultMessage: 'Custom',
		description:
			'Option to show a custom date range in the date input in the Dynamic Cards Search modal that opens when user is updating dynamic cards',
	},
	dateFilterCustomInvalidDateAfterToday: {
		id: 'dynamic-cards-search-page.date.filter.custom.invalid.after.today',
		defaultMessage: 'The From date can’t be in the future',
		description:
			'error displayed when a date range begins after the current date in the date input in the Dynamic Cards Search modal that opens when user is updating dynamic cards',
	},
	dateFilterCustomInvalidToDateAfterToday: {
		id: 'dynamic-cards-search-page.date.filter.custom.invalid.to.after.today',
		defaultMessage: 'The To date can’t be in the future',
		description:
			'error displayed when a date range ends after the current date in the date input in the Dynamic Cards Search modal that opens when user is updating dynamic cards',
	},
	dateFilterCustomInvalidDateAfterEnd: {
		id: 'dynamic-cards-search-page.date.filter.custom.invalid.after.end',
		defaultMessage: 'The From date has to be before the To date',
		description:
			'error displayed when a date range begins after the end date in the date input in the Dynamic Cards Search modal that opens when user is updating dynamic cards',
	},
	dateFilterToRange: {
		id: 'dynamic-cards-search-page.date.filter.to.range',
		defaultMessage: 'to',
		description:
			"Text between the 'from' and 'to' date pickers that signifies the date range is between these two dates. Located in the date input dropdown in the Dynamic Cards Search modal that opens when user is updating dynamic cards",
	},
	dateFilterUpdateButton: {
		id: 'dynamic-cards-search-page.date.filter.update.button',
		defaultMessage: 'Update',
		description:
			'Text for update button in date filter picker of the "Custom Range" option  in the date input dropdown in the Dynamic Cards Search modal that opens when user is updating dynamic cards',
	},
	dateFilterBeforeLabel: {
		id: 'dynamic-cards-search-page.date.filter.before.label',
		defaultMessage: 'before',
		description:
			'`before` text in date picker dropdown that appears before the chosen date indicating that the filter will show content before the specified date. Located in the Dynamic Cards Search modal that opens when user is updating dynamic card',
	},
	dateFilterAfterLabel: {
		id: 'dynamic-cards-search-page.date.filter.after.label',
		defaultMessage: 'after',
		description:
			'`after` text in date picker dropdown that appears before the chosen date indicating that the filter will show content after the specified date. Located in the Dynamic Cards Search modal that opens when user is updating dynamic card',
	},
});
